import React from 'react';
import {Field} from 'redux-form';

import {SelectField} from 'components/Fields';
import FormField from 'components/FormField';
import LabelV2 from 'components/LabelV2';

import {required} from 'utils/validators';

import './styles.css';

const PURPOSES_OPTIONS = [
  {value: 'long_stay', label: 'Long stay'},
  {value: 'short_stay', label: 'Short stay'},
  {value: 'guest', label: 'Guest'},
  {value: 'extended_stay', label: 'Extended stay'},
  {value: 'corporate', label: 'Corporate'}
];

const SelectRoomPurposeSection = () => (
  <FormField className="SelectRoomPurposeSection">
    <LabelV2>2.Choose room purpose</LabelV2>
    <Field
      name="roomPurpose"
      component={SelectField}
      options={PURPOSES_OPTIONS}
      validate={[required]}
      placeholder="Select..."
    />
  </FormField>
);

export default SelectRoomPurposeSection;
